/* Release Theme - v1.0.4 */

// const body = document.querySelector("body");
// const main = document.querySelector("main");

// let header = document.querySelector(
//   "#header, #shopify-section-main-password-header"
// );
// let announcementBar = document.querySelector(".js-announcement-bar");

// let heroBanner = document.querySelector(".hero-banner");

// let productMedia = document.querySelector(".main-product__media"); // on pdp
// let productMediaSwiper = document.querySelector(
//   ".main-product__media .swiper--product-gallery"
// ); // on pdp

// let productCardMedia = document.querySelector(".product-card__media");
// let productCardCollections = document.querySelector(".product-card");

// const mobileWidth = 750;
// const tabletWidth = 990;
// const windowDynamicEvents = ["scroll", "resize"];

// // define desktop, tablet, mobile
// const isDesktop = window.innerWidth > tabletWidth;
// const isTablet = window.innerWidth <= tabletWidth && window.innerWidth >= mobileWidth;
// const isMobile = window.innerWidth < mobileWidth;


function secondImgHoverStates2() {
  let landscapes = document.querySelectorAll(".product-card__actions");

  landscapes.forEach(ld => {
    if (ld.classList.contains('landscape-orientation') || ld.classList.contains('square-orientation')) {
        ld.addEventListener("mouseenter", () => {
          ld.classList.add("default-orientation")
          // ld.classList.remove("is--hovering")
      
        });
        ld.addEventListener("mouseout", () => {
          ld.classList.remove("default-orientation")
          // ld.classList.remove("is--hovering")
        });
    }
  });
}
// secondImgHoverStates2()

function insertDecimal(num) {
  return (num / 100).toFixed(2);
}

 async function getInstallPrice()  {
  try {
    const response = await fetch(window.Shopify.routes.root + 'products/installation.js', {
      method: 'GET',
    });
    const product = await response.json();
    let price = product.price;
    // return insertDecimal(product.price);
    return price;
  }
  catch (error) {
      console.error(error);
  }
}

async function hideInstallationBtn(){
  let btnAddInstallation = document.querySelector('.btn-installation')
  const response = await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  });
  const cart = await response.json();
  let qty = 0;

  cart.items.forEach(ld => {
    if(ld.variant_options[0].toLowerCase().replace(/\s/g, '') == 'frame-installation'){
      qty +=  ld.quantity
    }
  });
  if(qty > 0){
    document.querySelectorAll('.btn-installation').forEach(function(el) {
      el.style.display = 'none';
   });
    // btnAddInstallation.classList.add('visually-hidden')
  }
}

hideInstallationBtn()

async function addInstall() {
  let carts = document.querySelector('cart-items');
  let carts_drawer = document.querySelector('cart-drawer-items');
  carts?.classList.add('is-loading');
  carts_drawer?.classList.add('is-loading');
  
  const response = await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  });
  const cart = await response.json();
  let qty = 0;

  cart.items.forEach(ld => {
    let frameType = ld.variant_options[0].toLowerCase().replace(/\s/g, '')
    //product giftcard_variant_id
    //prevent adding installation print and gift card
    let giftcard_1_variant_id = window.giftCard100VariantID
    let giftcard_2_variant_id = window.giftCard200VariantID
    let giftcard_3_variant_id = window.giftCard300VariantID
    if( (frameType != 'print' && frameType != 'printonly') && frameType != 'frame-installation' && ld.variant_id != giftcard_1_variant_id && ld.variant_id != giftcard_2_variant_id && ld.variant_id != giftcard_3_variant_id){
      qty +=  ld.quantity
    }
  });

  let formData = {
    'items': [{
     'id': window.installationVariantID,//  installation_variant_id
     'quantity': qty
     }]
   };
 if(qty > 0) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)

  })
  .then(response => {
    carts?.classList.remove('is-loading');
    carts_drawer?.classList.remove('is-loading');
    _autoAddSingleProduct().then(() => {
      setTimeout(function() {
        window.location.href = '/cart';
      }, 3000);
  
    })
    // window.location.href = '/cart';
    return response.json();
 
  })
  .catch((error) => {
    console.error('Error:', error);
  });
 
 }else{
    carts?.classList.remove('is-loading');
    carts_drawer?.classList.remove('is-loading');
 }

}

async function getProductImage(){
  const response = await fetch(window.Shopify.routes.root + 'products/installation.js', {
    method: 'GET',
  });
  const product = await response.json();

  console.log(product.images[0])
}
//getProductImage()

async function updateInstallation() {

  const response = await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  });
  const cart = await response.json();
  let installation = 0;
  let qty = 0;

  cart.items.forEach(ld => {
    let frameType = ld.variant_options[0].toLowerCase().replace(/\s/g, '')

    if(frameType == 'frame-installation'){
      installation =  1
    }
  });

  cart.items.forEach(ld => {
    let frameType = ld.variant_options[0].toLowerCase().replace(/\s/g, '')
    //product giftcard_variant_id
    //prevent adding installation print and gift card
    let giftcard_1_variant_id = window.giftCard100VariantID
    let giftcard_2_variant_id = window.giftCard200VariantID
    let giftcard_3_variant_id = window.giftCard300VariantID
    if( (frameType != 'print' && frameType != 'printonly') && frameType != 'frame-installation' && ld.variant_id != giftcard_1_variant_id && ld.variant_id != giftcard_2_variant_id && ld.variant_id != giftcard_3_variant_id){
      qty += parseInt(ld.quantity) 
    }
  });
  await qty
 
  if(installation > 0){
    let variant_id = window.installationVariantID;
    let updates = {
      //installation_variant_id
      [variant_id]: qty
    };
    // alert(qty)
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });


  }
 
}
async function autoAddSingleProduct() {
  
  const {
    custom_auto_add_threshold: autoAddThreshold,
    custom_rand_threshold: custRandThreshold,
    money_with_currency_format: moneyFormat
  } = window.theme.settings;


  if(autoAddThreshold == 0 || window.autoAddVariantID == "0" || window.autoAddVariantID == 0)
  {
    return false;
  }

  let carts = document.querySelector('cart-items');
  let carts_drawer = document.querySelector('cart-drawer-items');
  carts?.classList.add('is-loading');
  carts_drawer?.classList.add('is-loading');

    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    });
    // const cart = await response.json();
    const {original_total_price,total_price, item_count, items } = await response.json();
    let qty = 0;

    // cart.items.forEach(ld => {
    items.forEach(ld => {
      let tocheck = window.autoAddVariantID
      // check if theres gift card
      if( ld.variant_id == tocheck ){
        qty +=  ld.quantity
      }
    });
    if(qty == 0 && (original_total_price / 100)  > (autoAddThreshold / 100)){
      let formData = {
        'items': [{
        'id': window.autoAddVariantID,//custom_gift_card_100_variant_id
        'quantity': 1
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
  
      })
      .then(response => {
        carts?.classList.remove('is-loading');
        carts_drawer?.classList.remove('is-loading');
        updateInstallation().then(() => window.location.href = '/cart');
        
        return response.json();
    
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }else if(qty > 0 && ((original_total_price / 100) - 100)  <= (autoAddThreshold / 100)){
    
      let variant_id = window.autoAddVariantID
      let updates = {
        //installation_variant_id
        [variant_id]: 0
      };
      // alert(qty)
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        carts?.classList.remove('is-loading');
        carts_drawer?.classList.remove('is-loading');
        updateInstallation().then(() => window.location.href = '/cart');

        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    carts?.classList.remove('is-loading');
    carts_drawer?.classList.remove('is-loading');

}
async function _autoAddSingleProduct() {
  const {
    custom_auto_add_threshold: autoAddThreshold,
    custom_rand_threshold: custRandThreshold,
    money_with_currency_format: moneyFormat
  } = window.theme.settings;


  if(autoAddThreshold == 0 || window.autoAddVariantID == "0" || window.autoAddVariantID == 0)
  {
    return false;
  }

  let carts = document.querySelector('cart-items');
  let carts_drawer = document.querySelector('cart-drawer-items');
  carts?.classList.add('is-loading');
  carts_drawer?.classList.add('is-loading');

    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    });
    // const cart = await response.json();
    const {original_total_price,total_price, item_count, items } = await response.json();
    let qty = 0;

    // cart.items.forEach(ld => {
    items.forEach(ld => {
      let tocheck = window.autoAddVariantID
      // check if theres gift card
      if( ld.variant_id == tocheck ){
        qty +=  ld.quantity
      }
    });
    if(qty == 0 && (original_total_price / 100)  > (autoAddThreshold / 100)){
      let formData = {
        'items': [{
        'id': window.autoAddVariantID,//custom_gift_card_100_variant_id
        'quantity': 1
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
  
      })
      .then(response => {
        updateInstallation();
        
        return response.json();
    
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }else if(qty > 0 && ((original_total_price / 100) - 100)  <= (autoAddThreshold / 100)){
    
      let variant_id = window.autoAddVariantID
      let updates = {
        //installation_variant_id
        [variant_id]: 0
      };
      // alert(qty)
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        updateInstallation();

        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    carts?.classList.remove('is-loading');
    carts_drawer?.classList.remove('is-loading');

}
function getRandomElement(arr) { 
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex]; 
}

async function autoRandomProduct() {

  const productArray = [
      window.autoRandVariantID1,
      window.autoRandVariantID2,
      window.autoRandVariantID3,
      window.autoRandVariantID4
    ]
    
  // console.log(productArray[getRandomInt(4)])
  // console.log(productArray.includes(43))
  // console.log(productArray.includes(window.autoRandVariantID1))

  const {
    custom_rand_threshold: randProdThreshold,
    money_with_currency_format: moneyFormat
  } = window.theme.settings;

  if(randProdThreshold == 0)
  {
    return false;
  }

  let carts = document.querySelector('cart-items');
  let carts_drawer = document.querySelector('cart-drawer-items');
  carts?.classList.add('is-loading');
  carts_drawer?.classList.add('is-loading');

    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    });
    // const cart = await response.json();
    const {original_total_price,total_price, item_count, items } = await response.json();
    let qty = 0;
    let randVariantIdtoRemove = 0;

    // cart.items.forEach(ld => {
    items.forEach(ld => {
      // check if there's already product in arry
      // if( ld.variant_id == tocheck ){
      if(productArray.includes(ld.variant_id)){
        randVariantIdtoRemove = ld.variant_id;
        qty +=  ld.quantity
      }
    });

    if(qty == 0 && (original_total_price / 100)  > (randProdThreshold / 100)){
      let formData = {
        'items': [{
        'id': getRandomElement(productArray),//Get random Variant ID
        'quantity': 1
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
  
      })
      .then(response => {
        carts?.classList.remove('is-loading');
        carts_drawer?.classList.remove('is-loading');
        updateInstallation().then(() => window.location.href = '/cart');
        
        return response.json();
    
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    
    else if(qty > 0 && ((original_total_price / 100) - 100)  <= (randProdThreshold / 100)){

      let randVar1 = window.autoRandVariantID1;
      let randVar2 = window.autoRandVariantID2;
      let randVar3 = window.autoRandVariantID3;
      let randVar4 = window.autoRandVariantID4;
      let variant_id = randVariantIdtoRemove
      
      let updates = {
        //installation_variant_id
        [randVar1]: 0,
        [randVar2]: 0,
        [randVar3]: 0,
        [randVar4]: 0
      };
      // let updates = {
      //   //installation_variant_id
      //   [variant_id]: 0
      // };
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        carts?.classList.remove('is-loading');
        carts_drawer?.classList.remove('is-loading');
        updateInstallation().then(() => window.location.href = '/cart');

        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    }

    carts?.classList.remove('is-loading');
    carts_drawer?.classList.remove('is-loading');

}

function clickableTestimonial() {
  let testimonialBox = document.querySelectorAll('.testimonial__box');
  testimonialBox.forEach(box => {
    box.classList.add("cursor-pointer")
    box.addEventListener('click', () => {
      window.location.href = 'https://www.google.com/maps/place/Drawdeck/@24.9671263,55.185131,895m/data=!3m1!1e3!4m6!3m5!1s0x3e5f69d5b3fcffff:0x19ade0dce6e0421e!8m2!3d24.9671263!4d55.185131!16s%2Fg%2F11fxx285c5?hl=en-GB&entry=ttu&g_ep=EgoyMDI0MTAxNC4wIKXMDSoASAFQAw%3D%3D'
    });

  });
  
}
clickableTestimonial();

function test() {
  alert('test')
}
